import { Service } from "typedi";
import { IGooglePayButtonDomInjector } from "./IGooglePayButtonDomInjector";

@Service()
export class GooglePayButtonDomInjector implements IGooglePayButtonDomInjector {
  addButtonToDom(buttonRootNode: string, button: Node): void {
    document.getElementById(buttonRootNode)?.appendChild(button);
  }
}
